import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getContractList(params) {
  return request({
    url: URL.partner.contract,
    method: 'get',
    params
  })
}

// 根据公司uuids所有合同
export function getContractsByCompanyUuids(uuids) {
  return request({
    url: URL.partner.contractsCompany,
    method: 'post',
    data: uuids
  })
}

export function saveContract(data) {
  return request({
    url: URL.partner.contract,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delContract(uuid) {
  return request({
    url: URL.partner.contract + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 是否禁止到期合同创建业务
export function isContractExpiredForbidCreateJob(params) {
  return request({
    url: URL.partner.isContractExpiredForbidCreateJob,
    method: 'get',
    params
  })
}

// 是否禁止到期合同创建业务
export function isContractExpiredForbidCreateJobs(cmpIdxList) {
  return request({
    url: URL.partner.isContractExpiredForbidCreateJobs,
    method: 'post',
    data: cmpIdxList
  })
}

// 合同管理 列表查询
export function queryContractPageable(data) {
  return request({
    url: URL.partner.queryContractPageable,
    method: 'post',
    data
  })
}

// 合同管理 列表左边查询
export function updateCountData(data) {
  return request({
    url: URL.partner.updateCountData,
    method: 'post',
    data
  })
}

// 合同管理 查询日志
export function queryContractLog(data) {
  return request({
    url: URL.partner.queryContractLog,
    method: 'post',
    data
  })
}

// 合同管理 撤销
export function revokeContract(data) {
  return request({
    url: URL.partner.revokeContract,
    method: 'post',
    data
  })
}

// 合同管理 客户已签订有合同数
export function getCompanyHasContractCount(data) {
  return request({
    url: URL.partner.getCompanyHasContractCount,
    method: 'post',
    data
  })
}

// 合同管理 保存
export function saveContractInfo(data) {
  return request({
    url: URL.partner.saveContract,
    method: 'post',
    data
  })
}

// 合同管理 获取合同配置
export function getContractConfig(data) {
  return request({
    url: URL.partner.getContractConfig,
    method: 'post',
    data
  })
}

// 合同管理 保存合同配置
export function saveContractConfig(data) {
  return request({
    url: URL.partner.saveContractConfig,
    method: 'post',
    data
  })
}

// 合同管理 审批成功之后将审核人和审核时间赋值
export function updateContractField(data) {
  return request({
    url: URL.partner.updateContractField,
    method: 'post',
    data
  })
}

// 启用合同限制
export function enableContractLimit(data) {
  return request({
    url: URL.partner.enableContractLimit,
    method: 'post',
    data
  })
}

// 禁用合同限制
export function disableContractLimit(data) {
  return request({
    url: URL.partner.disableContractLimit,
    method: 'post',
    data
  })
}

// 编辑放号天数（仅保存）
export function saveReleaseDays(data) {
  return request({
    url: URL.partner.saveReleaseDays,
    method: 'put',
    data
  })
}

// 编辑放号天数并转为票结
export function saveReleaseDaysAndConvertToTicket(data) {
  return request({
    url: URL.partner.saveReleaseDaysAndConvertToTicket,
    method: 'put',
    data
  })
}

// 获取放号天数编辑历史
export function getReleaseDaysHistory(params) {
  return request({
    url: URL.partner.getReleaseDaysHistory,
    method: 'get',
    params
  })
}

// 获取合同限制状态
export function getContractLimitStatus(params) {
  return request({
    url: URL.partner.getContractLimitStatus,
    method: 'get',
    params
  })
}
